import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Page Header */}
      <section className="page-header">
        <div className="header-overlay"></div>
        <div className="container">
          <div className="header-content">
            <div className="about-cert-badges">
              <span className="about-cert-badge">AN ISO 9001:2015 CERTIFIED SEED COMPANY</span>
              <span className="about-cert-badge">AN ISO 22000:2018 CERTIFIED SEED COMPANY</span>
            </div>
            <h1>About Gangaseed</h1>
            <p>GANGASEED® — THE FARMER'S NEED</p>
          </div>
        </div>
      </section>

      {/* About Us */}
      <section className="section company-description">
        <div className="container">
          <div className="description-content">
            <div className="description-text glass-card">
              <h2 className="section-title" style={{ textAlign: 'left' }}>About Us</h2>
              <p>
                Gangaseed Company is a progressive agricultural company dedicated to delivering
                high-quality seeds that empower farmers and enhance crop productivity. With a strong focus
                on innovation, research, and sustainability, we aim to support modern farming practices
                while preserving the essence of traditional agriculture.
              </p>
              <p>
                Our commitment lies in providing reliable, high-performance seeds that ensure better yield,
                disease resistance, and adaptability to diverse climatic conditions. We work closely with
                farmers, distributors, and agricultural experts to create solutions that contribute to
                long-term agricultural growth.
              </p>
            </div>
            <div className="description-image">
              <div className="image-card glass-card">
                <div className="about-icon">🌱</div>
                
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section mission-vision" style={{ backgroundColor: 'var(--white)' }}>
        <div className="container">
          <h2 className="section-title">Our Mission &amp; Vision</h2>
          <div className="mv-grid">
            <div className="mv-card glass-card">
              <div className="mv-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To provide superior-quality seeds through continuous research and innovation, enabling
                farmers to achieve higher productivity, profitability, and sustainability in agriculture.
              </p>
            </div>
            <div className="mv-card glass-card">
              <div className="mv-icon">👁️</div>
              <h3>Our Vision</h3>
              <p>
                To become a trusted leader in the seed industry by transforming agriculture with advanced
                seed technologies, ensuring food security, and improving the livelihoods of farmers
                across the nation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Directors Quotes */}
      <section className="section director-quotes">
        <div className="container">
          <h2 className="section-title">Directors' Quotes</h2>
          <div className="quotes-grid">
            <div className="quote-card glass-card">
              <div className="quote-icon">"</div>
              <p className="quote-text">
                "Every farmer's success is our true achievement. We are dedicated to providing seeds
                that bring better yield, better income, and a better life."
              </p>
              <div className="quote-author">
                <div className="author-image">👩‍💼</div>
                <div className="author-info">
                  <h4>Riti Naik Prajapati</h4>
                  <p>Director, Gangaseed Company</p>
                </div>
              </div>
            </div>
            <div className="quote-card glass-card">
              <div className="quote-icon">"</div>
              <p className="quote-text">
                "From soil to success, our mission is to stand beside farmers with reliable seeds
                and honest commitment."
              </p>
              <div className="quote-author">
                <div className="author-image">👨‍💼</div>
                <div className="author-info">
                  <h4>Tushar Prajapati</h4>
                  <p>Director, Gangaseed Company</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="section core-values">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">The principles that guide everything we do</p>
          <div className="values-grid">
            <div className="value-card glass-card">
              <div className="value-icon">💎</div>
              <h4>Quality Excellence</h4>
              <p>We never compromise on the quality of our seeds and services</p>
            </div>
            <div className="value-card glass-card">
              <div className="value-icon">🔬</div>
              <h4>Innovation</h4>
              <p>Continuous research and development to stay ahead</p>
            </div>
            <div className="value-card glass-card">
              <div className="value-icon">🤝</div>
              <h4>Integrity</h4>
              <p>Honest and transparent relationships with our partners</p>
            </div>
            <div className="value-card glass-card">
              <div className="value-icon">🌱</div>
              <h4>Sustainability</h4>
              <p>Committed to environmentally responsible practices</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
